import React, {useState, useEffect} from 'react';
import {toJS} from 'mobx';

import {Button, List, Popconfirm} from 'antd';
import store from "./store";
import {observer} from 'mobx-react';

import styles from '../layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function (props) {
  const { t } = useTranslation();
  const {addresses} = store
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    addresses.length === 0 && store.fetchAddresses()
  }, [addresses.length])

  const onEdit = (index) => {
    store.index = index
    store.address = store.addresses[index]
    props.setVisible()
  }

  const setDefault = (index) => {
    setLoading(true)
    store.index = index
    store.setDefault().finally(() => {
      setLoading(false)
    })

  }

  return (
    <React.Fragment>
      <List
        header=''
        footer=''
        dataSource={toJS(addresses)}
        split={false}
        pagination={false}
        loading={store.isFetching}
        renderItem={(item, index) => (
          <List.Item>

            <div key={item.id} className={styles.item}>
              <div className={styles.hd}>
                {
                  item['is_default'] ? (
                    <Button style={{color: 'red'}} type='text'>{t('默认地址')}</Button>
                  ) : (
                    <Button type='link' loading={loading && index === store.index} onClick={() => {
                      setDefault(index)
                    }}>{t('设为默认地址')}</Button>
                  )
                }
                <div style={{flex: 1}}/>
                <Button type='text' onClick={() => {
                  onEdit(index)
                }}>{t('编辑')}</Button>
                <Popconfirm
                  title={t('确定要删除吗?')}
                  onConfirm={() => {
                    store.delAddress(index)
                  }}
                  okText={t('确定')}
                  cancelText={t('取消')}>
                  <Button type='text'>{t('删除')}</Button>
                </Popconfirm>
              </div>

              <div className={styles.bd}>
                <div style={{width: '40%'}}>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('收货人姓名')}：</div>
                    <div className={styles.val}>{item.name}</div>
                  </div>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('邮政编码')}：</div>
                    <div className={styles.val}>{item.post}</div>
                  </div>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('省')}：</div>
                    <div className={styles.val}>{item.province}</div>
                  </div>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('区')}：</div>
                    <div className={styles.val}>{item.area}</div>
                  </div>

                </div>

                <div style={{width: '50%'}}>

                  <div className={styles.param}>
                    <div className={styles.label}>{t('手机')}：</div>
                    <div className={styles.val}>{item.phone}</div>
                  </div>
                  <div className={styles.param}>
                    <div className={styles.label}>{t('备注')}：</div>
                    <div className={styles.val}>{item.remark}</div>
                  </div>
                  <div className={styles.param}>
                    <div className={styles.label}>{t('市')}：</div>
                    <div className={styles.val}>{item.city}</div>
                  </div>
                  <div className={styles.param}>
                    <div className={styles.label}>{t('地址')}：</div>
                    <div className={styles.val}>{item.details}</div>
                  </div>

                </div>


              </div>
            </div>

          </List.Item>
        )}
      />
    </React.Fragment>
  )
})
